export var rowGutter = [38, 32];
